export const baseUrl = "https://backend.romapharmacy.store/api";

export const loginURL = "login";

export const productsURL ="/dashboard/products"

export const categoriesURL ="/dashboard/categories"

export const privacyPolicyURL="/dashboard/privacy-policy"

export const discountCouponsURL="/dashboard/discount-coupons"

export const clientsURL = "clients/";

export const trainersURL = "trainers";

export const clientURL = "dashboard/clients";

export const usersURL = "users";

export const permissionsURL = "permissions";

export const notificationsURL = "notifications";

export const statisticsURL = "/dashboard/statistics";

export const departmentsURL = "departments";

export const contactUsURL = "contact-us";

export const ordersURL = "/dashboard/orders";

export const advertisementsURL="/dashboard/advertisements"

export const storeInfoURL="/dashboard/store-info"


